import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

const webTitles = {
  'Home': '萧山云平台',
  'Search': '搜索',
  'HotCo': '全部企业',
  'Detail': '岗位详情',
  'Xiugai': '简历修改',
  'Rule': '服务声明',
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {keepAlive: true}
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/Search.vue')
  },
  {
    path: '/hotco',
    name: 'HotCo',
    component: () => import('../views/HotCo.vue')
  },
  {
    path: '/company/:coname',
    name: 'Company',
    component: () => import('../views/Company.vue')
  },
  {
    path: '/detail/:jobid',
    name: 'Detail',
    component: () => import('../views/Detail.vue')
  },
  {
    path: '/intrduce',
    name: 'Intrduce',
    component: () => import('../views/Intrduce.vue')
  },
  {
    path: '/groundframe/:initTab',
    name: 'GroundFrame',
    component: () => import('../views/GroundFrame.vue'),
    meta: {keepAlive: true}
  },
  {
    path: '/jianlixiugai',
    name: 'Xiugai',
    component: () => import('../views/Xiugai.vue'),
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/Service.vue'),
  },
  {
    path: '/talentall',
    name: 'Talentall',
    component: () => import('../views/Talentall.vue'),
  },
  {
    path: '/talent/:type',
    name: 'Talent',
    component: () => import('../views/Talent.vue'),
  },
  // {
  //   path: '/career/:',
  //   name: 'Career',
  //   component: () => import('../views/Career.vue'),
  // },
  // {
  //   path: '/rule',
  //   name: 'Rule',
  //   component: () => import('../views/Rule.vue'),
  // },
]

const router = new VueRouter({
  routes
})

router.afterEach((to, from) => {
  window.document.title = webTitles[to.name] || '萧山云平台';
})

export default router
